var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"typewriterElement",staticClass:"typewriter-element"},[_vm._v(_vm._s(_vm.currentText)+" "),(_vm.isAnimating && !_vm.hideCursor)?_c('span',{staticClass:"blink"},[_vm._v("|")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }